// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2_yb0","bigColWidth":"Table_bigColWidth__2jgFT","biggerColWidth":"Table_biggerColWidth__1ynuH","row":"Table_row__1hJF3","col":"Table_col__2LPTM"};